module.exports = __webpack_public_path__ + "media/mindwell-logo/mindwell-logo-v2-aa4cde21.svg";